// Usage: stop click events from propagating out of an element, without having to use a click attribute (like ng-click or hm-click)
// this directive won't do anything if ng-click or hm-click is already defined, because it will already get handled properly
// by those directives
(function (angular) {
    'use strict';

    // click attributes
    var hmClick = 'hmClick';
    var ngClick = 'ngClick';

    angular.module('aprima-core-ui').directive('hmStopPropagation', [
        'ClickListenerService',
        hmStopPropagation,
    ]);


    function hmStopPropagation(
        ClickListenerService
    ) {
        var directive =  {
            restrict: 'A',
            link: link,
        };

        return directive;

        function link(
            scope,
            element,
            attrs
        ) {
            if(!attrs.hasOwnProperty(ngClick) && !attrs.hasOwnProperty(hmClick)) {
                // don't need this attribute to actually be compiled, just have to set it here,
                // so the ClickListenerService picks it up
                attrs[ngClick] = '';
                ClickListenerService.registerFromDirective(scope, element, attrs, ngClick);
            }
        }
    }

})(window.angular);